import { useState } from 'react'
import { Box, Grid2, IconButton, Stack, Typography } from '@mui/material'
import CustomDivider from '../../../shared/utils/CustomDivider'
import { NormalContainerWithHeader } from '../../../shared/components/student/NormalComponent'
import { Field } from 'formik'
import * as Yup from 'yup'
import { useAllAdminCity, useAllAdminCountry, useAllAdminState } from '../../../assets/api/useAdminApi'
import { IdAutoCompleteField } from '../../../shared/components/formfields/IdAutoCompleteField'
import CityForm from './CityForm'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useToaster } from '../../../shared/utils/ToasterProvider'
import EditIcon from '@mui/icons-material/Edit';
import TableFilterTemplate from '../../../shared/utils/TableFilterTemplate'
import ToggleSwitch from '../../../shared/utils/CustomToggle'
import api from '../../../assets/nodeApi/axiosInstance'

const City = () => {
  const { showToaster } = useToaster();
  const queryClient = useQueryClient();
  const [selectedCity, setSelectedCity] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [filters, setFilters] = useState({
    state_id: 1233,
    country_id: 99
  });
  const [searchState, setSearchState] = useState("")
  const { data: cityList, isLoading: cityLoading } = useAllAdminCity(filters);
  const [countryId, setCountryId] = useState("");
  const { data: stateList, isLoading: stateLoading } = useAllAdminState({ country_id: countryId, search: searchState });
  const { data: countryList, isLoading: countryLoading } = useAllAdminCountry();
  const countryOption = countryList?.data?.map((item) => ({
    id: item?.id,
    label: item?.country_name,
    value: item?.country_name,
  }))

  const stateOption = stateList?.data?.map((item) => ({
    id: item?.id,
    label: item?.state_name,
    value: item?.state_name,
  }))

  const validationSchema = Yup.object().shape({
    state_id: Yup.string().required("State is required"),
    country_id: Yup.string().required("Country is required"),
    status: Yup.string().required("Status is required"),
  });

  const handleFormSuccess = () => {
    setIsEditing(false);
    setSelectedCity(null);
  };

  // const mutationUpdate = useMutation({
  //   mutationFn: (formData) => api.put(`region/update-status`, formData),
  // });
  const mutationUpdate = useMutation({
    mutationFn: ({ data, id }) =>
      api.put(`region/update-status/${id}`, data),
  });
  const handleToggleChange = (row) => {
    const obj = {
      "table": "cities",
      "status": row?.status == 1 ? false : true
    }
    mutationUpdate.mutate({ data: obj, id: row?.id }, {
      onSuccess: (response) => {
        if (response?.data?.message) {
          showToaster("City updated successfully!", '', 'success');
          queryClient.invalidateQueries({ queryKey: ["all-cities-list"] });

        } else {
          showToaster('Something went wrong!', '', 'error');
        }
      },
      onError: (error) => {
        showToaster(error?.data?.error || "Failed to update City", '', 'error');
      }
    });
  };
  const cityColumns = [
    {
      field: "sr_no",
      headerName: "Sr No",
      flex: 1,
      renderCell: (params) => <Typography variant="body2">{params.value}</Typography>

    },
    {
      field: "city_name",
      headerName: "City Name",
      flex: 1,
      renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
    },
    {
      field: "state_name",
      headerName: "State",
      flex: 1,
      renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
    },
    {
      field: "country_name",
      headerName: "Country",
      flex: 1,
      renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      renderCell: (params) => <Typography variant="body2">{params.value === 1 ? "Active" : "Inactive"}</Typography>,
    },
    {
      field: "actionsEdit",
      headerName: "Edit",
      flex: 1,
      renderCell: (params) => (
        <Stack direction="row" spacing={1}>
          <IconButton
            onClick={() => {
              setSelectedCity(params.row);
              setIsEditing(true);
              window.scrollTo({ top: 0, behavior: 'smooth' });

            }}
            size="small"
          >
            <EditIcon color="text.primary" />
          </IconButton>
        </Stack>
      ),
    },
    {
      field: "actionsDelete",
      headerName: "Change Status",
      width: 200,
      renderCell: (params) => (
        <Stack direction="row" spacing={1}>
          <ToggleSwitch checked={params?.row?.status} onCheck={() => handleToggleChange(params?.row)} />
        </Stack>
      ),
    }
  ];
  return (
    <Box>
      <CustomDivider />

      <NormalContainerWithHeader headerText={isEditing ? "Edit City" : "Add City"}>
        <CityForm
          initialCity={selectedCity}
          isEditing={isEditing}
          enableReinitialize={true}
          onSuccess={handleFormSuccess}
        />
      </NormalContainerWithHeader>

      <CustomDivider />


      <TableFilterTemplate
        title="City List"
        columns={cityColumns}
        rowsData={cityList?.data || []}
        isLoading={cityLoading}
        filterInitialValues={filters}
        filterReset={() => setFilters({})}
        onApplyFilters={(f) => setFilters(f)}

        renderFilterFields={() => (
          <>

            <Grid2 children size={12}>
              <Field
                name="country_id"
                component={IdAutoCompleteField}
                options={countryOption}
                label="Select Country"
                isRequired={true}
                isLoading={countryLoading}
                onValueChange={(value) => {
                  setCountryId(value?.id);
                }}
              />
            </Grid2>
            <Grid2 children size={12}>
              <Field
                name="state_id"
                component={IdAutoCompleteField}
                options={stateOption}
                label="Select State"
                isRequired={true}
                isLoading={stateLoading}
                onSearchChange={(val) => {
                  setSearchState(val)
                }}
              />
            </Grid2>
            <Grid2 children size={12}>
              <Field
                name="status"
                component={IdAutoCompleteField}
                options={[
                  { id: 1, label: "Active", value: "Active" },
                  { id: 0, label: "Inactive", value: "Inactive" }
                ]}
                isRequired={true}
                label="Status"
              />
            </Grid2>
          </>
        )}
      />



    </Box>
  )
}

export default City